import {REPORT_ADD_PENDING, REPORT_REMOVE_PENDING} from "../actions/report"

const _getDefaultState = () => ({
  pending: []
})

const ReportReducer = (state = _getDefaultState(), action) => {
  const {type} = action

  switch (type) {
    case REPORT_ADD_PENDING: {
      return {
        ...state,
        pending: [...state.pending, {uuid: action.uuid, isDemo: action.isDemo}]
      }
    }
    case REPORT_REMOVE_PENDING: {
      return {
        ...state,
        pending: [...state.pending.filter(({uuid}) => uuid !== action.uuid)]
      }
    }
    default:
      return state
  }
}

export default ReportReducer
